import { Alert, Box, Button, Card, CardContent, CircularProgress, Stack, Typography } from '@mui/material';
import MarkEmailReadRoundedIcon from '@mui/icons-material/MarkEmailReadRounded';
import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export default function EmailConfirmationPage() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { confirmEmail } = useAuth();
  const [status, setStatus] = useState('loading');
  const [message, setMessage] = useState('Confirmation en cours...');

  useEffect(() => {
    const token = searchParams.get('token');
    if (!token) {
      setStatus('error');
      setMessage('Lien de confirmation incomplet.');
      return;
    }

    confirmEmail(token)
      .then(() => {
        setStatus('success');
        setMessage('Email confirmé. Vous pouvez choisir votre accès.');
      })
      .catch((err) => {
        setStatus('error');
        setMessage(err.message);
      });
  }, [confirmEmail, searchParams]);

  return (
    <Box sx={{ minHeight: '100vh', display: 'grid', placeItems: 'center', p: 3 }}>
      <Card variant="outlined" sx={{ width: '100%', maxWidth: 480 }}>
        <CardContent sx={{ p: { xs: 3, sm: 4 } }}>
          <Stack spacing={3} alignItems="center" textAlign="center">
            {status === 'loading' ? (
              <CircularProgress />
            ) : (
              <MarkEmailReadRoundedIcon color={status === 'success' ? 'success' : 'error'} sx={{ fontSize: 46 }} />
            )}
            <Typography variant="h5" sx={{ fontWeight: 850 }}>
              Confirmation email
            </Typography>
            <Alert severity={status === 'success' ? 'success' : status === 'error' ? 'error' : 'info'} sx={{ width: '100%' }}>
              {message}
            </Alert>
            <Button
              variant="contained"
              disabled={status === 'loading'}
              onClick={() => navigate(status === 'success' ? '/connexion' : '/auth')}
            >
              Continuer
            </Button>
          </Stack>
        </CardContent>
      </Card>
    </Box>
  );
}
